export const EVENT_ORIGIN = {
  REORDER: 'reorder',
  MENU: 'menu',
  CART_MODIFY: 'cart modify',
};

export const ERROR = {
  QUANTITY_NOT_REACHED: 'quantity_not_reached',
  MANDATORY_OPTION_MISSING: 'obligatory_choices_missing',
};
